import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from '../ui/dialog';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '../ui/select';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { monthLabel } from './perfMeta';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Dialog « Définir les objectifs » pour un commercial sur une période.
export const TargetsDialog = ({ open, onClose, commercials = [], period, preselect, onSaved }) => {
  const [commercialId, setCommercialId] = useState('');
  const [form, setForm] = useState({ caTarget: '', opsTarget: '', invoicesTarget: '', commissionRate: '5' });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) {
      const id = preselect?.commercialId || commercials[0]?.commercialId || '';
      setCommercialId(id);
      setForm({ caTarget: '', opsTarget: '', invoicesTarget: '', commissionRate: '5' });
    }
  }, [open, preselect, commercials]);

  const save = async () => {
    if (!commercialId) { toast.error('Sélectionnez un commercial'); return; }
    setSaving(true);
    try {
      await axios.post(`${API}/admin/commercials/${commercialId}/targets`, {
        period,
        periodType: 'monthly',
        caTarget: Number(form.caTarget) || 0,
        opsTarget: Number(form.opsTarget) || 0,
        invoicesTarget: Number(form.invoicesTarget) || 0,
        commissionRate: (Number(form.commissionRate) || 0) / 100,
      });
      toast.success('Objectif défini');
      onSaved && onSaved();
      onClose();
    } catch (e) { toast.error(e?.response?.data?.detail || 'Échec de l\'enregistrement'); }
    finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="perf-targets-dialog">
        <DialogHeader><DialogTitle>Définir les objectifs — {monthLabel(period)}</DialogTitle></DialogHeader>
        <div className="space-y-4">
          <div>
            <Label className="text-sm">Commercial</Label>
            <Select value={commercialId} onValueChange={setCommercialId}>
              <SelectTrigger data-testid="perf-target-commercial"><SelectValue placeholder="Choisir…" /></SelectTrigger>
              <SelectContent>
                {commercials.map((c) => <SelectItem key={c.commercialId} value={c.commercialId}>{c.commercialName}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div><Label className="text-sm">Objectif CA (XOF)</Label><Input type="number" value={form.caTarget} onChange={(e) => setForm({ ...form, caTarget: e.target.value })} placeholder="0" data-testid="perf-target-ca" /></div>
            <div><Label className="text-sm">Objectif opérations</Label><Input type="number" value={form.opsTarget} onChange={(e) => setForm({ ...form, opsTarget: e.target.value })} placeholder="0" data-testid="perf-target-ops" /></div>
            <div><Label className="text-sm">Objectif factures</Label><Input type="number" value={form.invoicesTarget} onChange={(e) => setForm({ ...form, invoicesTarget: e.target.value })} placeholder="0" data-testid="perf-target-invoices" /></div>
            <div><Label className="text-sm">Taux de commission (%)</Label><Input type="number" value={form.commissionRate} onChange={(e) => setForm({ ...form, commissionRate: e.target.value })} placeholder="5" data-testid="perf-target-rate" /></div>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="perf-target-cancel">Annuler</Button>
          <Button className="bg-emerald-600 hover:bg-emerald-700" onClick={save} disabled={saving} data-testid="perf-target-save">{saving ? 'Enregistrement…' : 'Enregistrer'}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default TargetsDialog;
